import { type FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { TRADE, CONSUMER } from 'dibs-buyer-layout/exports/userTypeEnums';
import { ProductTileAd } from 'dibs-google-ad-manager/exports/ProductTileAd';
import { getProductTileAdMap } from '../../utils/adHelpers';
import { useSbSelector } from '../../reducers/useSbSelector';
import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';

import { type SbSharedProductAdWrapper_itemSearch$data } from './__generated__/SbSharedProductAdWrapper_itemSearch.graphql';

type Props = {
    index: number;
    pageCol?: number;
    itemSearch: SbSharedProductAdWrapper_itemSearch$data;
};

export const SbSharedProductAdWrapperComponent: FC<Props> = ({ index, pageCol, itemSearch }) => {
    const relayVariables = useSbSelector(state => state.relayVariables.variables);
    const { isDesktop, isSbAdsEnabled } = useServerVarsContext();
    // reading isTrade value from relay vars b/c we need to get correct ad config values
    // during first render when google tag script starts loading ads.
    const showTradeAds = relayVariables.isTrade;

    const adMap = getProductTileAdMap({
        uriRef: itemSearch?.displayUriRef || '',
        pageCol,
        pageSize: relayVariables.first ?? 60,
        userType: showTradeAds ? TRADE : CONSUMER,
        deviceType: isDesktop ? 'desktop' : 'mobile',
        isSbAdsEnabled,
    });

    const ad = adMap[index + 1]; // 1-indexed

    if (!ad) {
        return null;
    }

    return <ProductTileAd {...ad} lazyLoad />;
};

export const SbSharedProductAdWrapper = createFragmentContainer(SbSharedProductAdWrapperComponent, {
    itemSearch: graphql`
        fragment SbSharedProductAdWrapper_itemSearch on ItemSearchQueryConnection {
            displayUriRef
        }
    `,
});
